package com.nonopn.skywatcher.common.app.pages.map.model.weather

import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.short_hour
import com.nonopn.skywatcher.common.app.res.short_minute
import com.nonopn.skywatcher.common.app.res.short_second
import com.nonopn.skywatcher.maps.LatLng
import org.jetbrains.compose.resources.StringResource
import kotlin.math.absoluteValue
import kotlin.math.roundToInt
import kotlin.math.sign

enum class TimeType(val stringResource: StringResource) {
    Hour(Res.string.short_hour),
    Min(Res.string.short_minute),
    Sec(Res.string.short_second)
}

data class ThunderActivityCondensed(
    val distance: String,
    val intensity: String,
    val intensityNumber: Long,
    val distanceKm: Int,
    val createdAtDiff: Long,
    val createdAtType: TimeType,
    val createdAtDiffAbsolute: Long
)

fun ThunderDetectionActivity.toCondensed(
    position: LatLng,
    timestampSeconds: Long
): ThunderActivityCondensed {
    val sign = if (pulsePeakAmp.sign < 0) "-" else "+"
    val distanceKm = distance(position).roundToInt()

    val diff = timestampSeconds - this.recTimestampSeconds
    val minutes = diff / 60
    val hours = minutes / 60

    val actualDiff = when {
        hours > 0 -> hours to TimeType.Hour
        minutes > 0 -> minutes to TimeType.Min
        else -> diff to TimeType.Sec
    }

    return ThunderActivityCondensed(
        intensity = "$sign ${pulsePeakAmp.absoluteValue / 1000}kA",
        distance = "${distanceKm}km",
        distanceKm = distanceKm,
        createdAtDiff = actualDiff.first,
        createdAtType = actualDiff.second,
        intensityNumber = pulsePeakAmp.toLong(),
        createdAtDiffAbsolute = recTimestampSeconds
    )
}